import React from 'react';
import CartItemList from '../CartItemList';
import styles from './ItemsInCart.module.scss';

export interface ItemsInCartProps {
  allowRemoveCartItem?: boolean;
  allowRemoveCode?: boolean;
  /** controls the default expanded state of WhatsIncluded in CartItemV2 (default: true) */
  defaultExpanded?: boolean;
}

export default function ItemsInCart({ allowRemoveCartItem, defaultExpanded }: ItemsInCartProps) {
  return (
    <div className={styles.main}>
      <CartItemList allowRemoveCartItem={allowRemoveCartItem} defaultExpanded={defaultExpanded} />
    </div>
  );
}
